import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../user/user.service';
import { NavigationComponent } from '../../shared/navigation/navigation.component';
import { MatFormField, MatHint, MatInput, MatLabel } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
  imports: [
    NavigationComponent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatHint,
    MatInput,
    MatButton,
  ],
})
export class RegistrationComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly user = inject(UserService);

  form = new UntypedFormGroup({
    product: new UntypedFormControl({ value: '' }, Validators.required),
    pin: new UntypedFormControl(
      { value: undefined, disabled: false },
      Validators.required,
    ),
  });

  ngOnInit(): void {
    const product = this.form.get('product')!;
    const pin = this.form.get('pin')!;

    product.valueChanges.subscribe(() => {
      if (product.valid) {
        pin.enable();
      }
    });
  }

  onSubmit() {
    const product = this.form.get('product')!.value;
    let pin = this.form.get('pin')!.value;
    if (product === 'ladeloesung') {
      pin = null;
    }
    this.user.registerProduct(product, pin).subscribe(() => {
      this.router.navigateByUrl(
        '/' + this.form.get('product')!.value + '/welcome',
      );
    });
  }

  isButtonDisabled(): boolean {
    return (
      this.form.controls.product.value !== 'ladeloesung' &&
      this.form.controls.pin.invalid
    );
  }
}
